import StarfieldCanvas from "../../components/StarfieldCanvas/StarfieldCanvas";
import Page from "../../components/PageContainer/Page";
import styles from "./Home.module.scss";
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();

  return (
    <Page name="main">
      <StarfieldCanvas />
      <div className={styles.content}>
        <div className={styles.text}>
          <h1>{t('home.title')}</h1>
          <h2>{t('home.subtitle')}</h2>
        </div>
      </div>
    </Page>
  );
};

export default Home;